"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var browser_rum_1 = require("@datadog/browser-rum");
var conf = (_a = window.REMOTA) === null || _a === void 0 ? void 0 : _a.dd;
if (conf && conf.applicationId && conf.clientToken) {
    browser_rum_1.datadogRum.init(conf);
}
